<template>
  <div v-if="user == 0 && (owner === 'drr')">
    <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <b-img
          class="mr-1 mb-1"
          height="25"
          src="@/assets/images/icons/gred.svg"
        />
        <span style="font-size:20px; color: #fff; font-weight: 600;">สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน (Analytic)</span>
      </div>
      <div>
        <app-echar-line
          :option-data="option"
        />
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEcharLine from '@/views/dashboard/garaphLineDB/AppEchartLineDB.vue'

export default {
  name: 'WeeklyAccidentAnalytics',
  components: {
    BImg,
    BCard,
    AppEcharLine,
  },
  data() {
    return {
      user: '',
      owner: '',
      option: {
        xAxisData: [],
        series: [
          {
            name: 'รถย้อนศร',
            type: 'line',
            areaStyle: {
              color: '#FF805D',
            },
            color: '#FF805D',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          {
            name: 'รถหยุด',
            type: 'line',
            areaStyle: {
              color: '#FDFF01',
            },
            color: '#FDFF01',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  mounted() {
    this.user = this.userData.department
    this.owner = this.userData.groupname
    this.getbarChartCounting()
  },
  methods: {
    getbarChartCounting() {
      axios
        .post('/getGraphAnalyticDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })
        .then(response => {
          this.xAxisData = []
          this.xAxisData[0] = response.data
          this.xAxisData[0][0].forEach(value => {
            if (response.data[0].length >= 5) {
              this.option.xAxisData.push(value.Date_Name)
            }
            this.option.series[0].data.push(value.Wrong_Way)
          })
          this.xAxisData[0][1].forEach(value => {
            this.option.series[1].data.push(value.Car_Stop)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
